import { render, staticRenderFns } from "./CardProducts.vue?vue&type=template&id=7249f616&scoped=true"
import script from "./CardProducts.vue?vue&type=script&lang=js"
export * from "./CardProducts.vue?vue&type=script&lang=js"
import style0 from "./CardProducts.vue?vue&type=style&index=0&id=7249f616&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7249f616",
  null
  
)

export default component.exports